import React from "react";
import { useTranslation } from "react-i18next";
import HelpTextAccordion from "./HelpTextAccordion";

export interface ResultProps {
  fieldName: string;
  className?: string;
  labelExtra?: string;
  children?: React.ReactElement | React.ReactElement[];
}
const CalculationResult: React.FC<ResultProps> = ({
  fieldName,
  className,
  labelExtra,
  children,
}) => {
  const { t } = useTranslation();

  if (!children) {
    return <></>;
  }

  const unit =
    t(`${fieldName}.unit`) === `${fieldName}.unit`
      ? ""
      : t(`${fieldName}.unit`);
  const currencySymbol =
    t(`${fieldName}.currencySymbol`) === `${fieldName}.currencySymbol`
      ? undefined
      : t(`${fieldName}.currencySymbol`);
  const timePeriod =
    t(`${fieldName}.timePeriod`) === `${fieldName}.timePeriod`
      ? undefined
      : t(`${fieldName}.timePeriod`);
  const isFullUnitFormat =
    currencySymbol !== undefined && timePeriod !== undefined;
  const label = t(
    `${fieldName}.label`,
    labelExtra ? { year: labelExtra } : undefined,
  );
  const labelExtraText = labelExtra
    ? t(`${fieldName}.labelExtra`, { year: labelExtra })
    : `${fieldName}.labelExtra`;
  const resolvedLabelExtra =
    labelExtraText !== `${fieldName}.labelExtra`
      ? labelExtraText
      : undefined;

  return (
    <div
      className={`result-section ${className ? className : ""}`}
      data-testid={`${fieldName}-section`}
    >
      {label !== `${fieldName}.label` ? (
        <h4 className="result-label" id={`${fieldName}-label`}>
          {label}
          {resolvedLabelExtra ? ` ${resolvedLabelExtra}` : ""}
        </h4>
      ) : null}
      <HelpTextAccordion fieldName={fieldName} />
      {isFullUnitFormat && (
        <h4
          className={"result-value"}
          data-testid={`${fieldName}`}
          id={fieldName}
          aria-labelledby={`${fieldName}-label`}
        >
          {currencySymbol}
          {children} {timePeriod}
        </h4>
      )}
      {!isFullUnitFormat && (
        <div
          className={"result-value"}
          data-testid={`${fieldName}`}
          id={fieldName}
          aria-labelledby={`${fieldName}-label`}
        >
          {children} {unit}
        </div>
      )}
    </div>
  );
};

export default CalculationResult;
